import Login from '../pages/Auth/Login';
import RestaurantDetail from '../pages/RestaurantDetail';
import Register from '../pages/Auth/Register';
import ForgotPassword from '../pages/Auth/ForgotPassword';
import AdminDashboard from '../pages/Dashboard/AdminDashboard';
import ManagerDashboard from '../pages/Dashboard/ManagerDashboard';
import { ROLES } from '.';
import ManageUsers from '../pages/ManageUsers';
import ResetPassword from '../pages/Auth/ResetPassword';
import { encodeId } from '../helper/hashids';

export const getRoutes = () => {
  return {
    register: {
      permission: false,
      path: '/auth/register',
      name: 'Register',
      route: () => '/auth/register',
      element: Register,
    },
    login: {
      permission: false,
      path: '/auth/login',
      name: 'Login',
      route: () => '/auth/login',
      element: Login,
    },
    forgot_password: {
      permission: false,
      path: '/auth/forgot-password',
      name: 'Forgot Password',
      route: () => '/auth/forgot-password',
      element: ForgotPassword,
    },
    reset_password: {
      permission: false,
      path: '/auth/reset-password',
      name: 'Reset Password',
      route: (id) => `/auth/reset-password`,
      element: ResetPassword,
    },
    admin_dashboard: {
      permission: true,
      path: '/admin/dashboard',
      name: 'Admin Dashboard',
      route: () => `/admin/dashboard`,
      element: AdminDashboard,
      allowRoles: [ROLES.SUPERADMIN, ROLES.ADMIN],
    },
    manager_dashboard: {
      permission: true,
      path: '/manager/dashboard',
      name: 'Manager Dashboard',
      route: () => `/manager/dashboard`,
      element: ManagerDashboard,
      allowRoles: [ROLES.MANAGER],
    },
    restaurant_detail: {
      permission: true,
      path: '/site/:id',
      name: 'Site Detail',
      route: (id) => `/site/${encodeId(id)}`,
      element: RestaurantDetail,
      allowRoles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.STAFF],
    },
    manage_users: {
      permission: true,
      path: '/manage-users',
      name: 'Manage Users',
      route: (id) => `/manage-users`,
      element: ManageUsers,
      allowRoles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.MANAGER],
    },
  };
};
